// extracted by mini-css-extract-plugin
export default {"settings":"settings_settings__vQkLj"};